import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ClientsEffects } from './clients';
import * as fromClients from './clients/clients.reducer';
import { JobTypeEffects } from './job-types';
import * as fromJobTypes from './job-types/job-types.reducer';
import { PaginatedClientEffects } from './paginated-clients';
import * as fromPaginatedClient from './paginated-clients/paginated-client.reducer';
import { PaginatedJobTypeEffects } from './paginated-job-types';
import * as fromPaginatedJobTypes from './paginated-job-types/paginated-job-type.reducer';
import { PaginatedPermitTaskEffects } from './paginated-permit-tasks';
import * as fromPaginatedPermitTask from './paginated-permit-tasks/paginated-permit-task.reducer';
import { PaginatedProjectJobEffects } from './paginated-project-jobs';
import * as fromPaginatedProjectJob from './paginated-project-jobs/paginated-project-job.reducer';
import { PaginatedProjectEffects } from './paginated-projects';
import * as fromPaginatedProject from './paginated-projects/paginated-project.reducer';
import { PaginatedSurveyTaskEffects } from './paginated-survey-tasks';
import * as fromPaginatedSurveyTask from './paginated-survey-tasks/paginated-survey-task.reducer';
import { PaginatedTimeTrackingEffects } from './paginated-time-tracking';
import * as fromPaginatedTimeTracking from './paginated-time-tracking/paginated-time-tracking.reducer';
import { PaginatedUserEffects } from './paginated-users';
import * as fromPaginatedUser from './paginated-users/paginated-user.reducer';
import { ProjectDetailsEffects } from './project-details';
import * as fromProjectDetails from './project-details/project-details.reducer';
import { ProjectJobsEffects } from './project-jobs';
import * as fromProjectJobs from './project-jobs/project-jobs.reducer';
import { ProjectsEffects } from './projects';
import * as fromProjects from './projects/projects.reducer';
import { SettingsEffects } from './settings/settings.effects';
import * as fromSettings from './settings/settings.reducer';
import { SurveyTasksEffects } from './survey-tasks';
import * as fromSurveyTasks from './survey-tasks/survey-tasks.reducer';
import { TimeTrackingEffects } from './time-tracking';
import * as fromTimeTracking from './time-tracking/time-tracking.reducer';
import { UsersEffects } from './users';
import * as fromUsers from './users/users.reducer';
import { UtilitiesFacade } from './utilities/utilities.facade';
import * as fromUtilities from './utilities/utilities.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromClients.clientsFeatureKey, fromClients.reducer),
    StoreModule.forFeature(
      fromJobTypes.jobTypesFeatureKey,
      fromJobTypes.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedClient.paginatedClientFeatureKey,
      fromPaginatedClient.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedJobTypes.paginatedJobTypeFeatureKey,
      fromPaginatedJobTypes.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedProject.paginatedProjectFeatureKey,
      fromPaginatedProject.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedProjectJob.paginatedProjectJobFeatureKey,
      fromPaginatedProjectJob.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedPermitTask.paginatedPermitTaskFeatureKey,
      fromPaginatedPermitTask.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedSurveyTask.paginatedSurveyTaskFeatureKey,
      fromPaginatedSurveyTask.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedTimeTracking.paginatedTimeTrackingFeatureKey,
      fromPaginatedTimeTracking.reducer,
    ),
    StoreModule.forFeature(
      fromPaginatedUser.paginatedUserFeatureKey,
      fromPaginatedUser.reducer,
    ),
    StoreModule.forFeature(
      fromProjectDetails.projectDetailsFeatureKey,
      fromProjectDetails.reducer,
    ),
    StoreModule.forFeature(
      fromProjects.projectsFeatureKey,
      fromProjects.reducer,
    ),
    StoreModule.forFeature(
      fromProjectJobs.projectJobsFeatureKey,
      fromProjectJobs.reducer,
    ),
    StoreModule.forFeature(
      fromSettings.settingsFeatureKey,
      fromSettings.reducer,
    ),
    StoreModule.forFeature(
      fromSurveyTasks.surveyTasksFeatureKey,
      fromSurveyTasks.reducer,
    ),
    StoreModule.forFeature(
      fromTimeTracking.timeTrackingsFeatureKey,
      fromTimeTracking.reducer,
    ),
    StoreModule.forFeature(fromUsers.usersFeatureKey, fromUsers.reducer),
    StoreModule.forFeature(
      fromUtilities.UTILITIES_FEATURE_KEY,
      fromUtilities.utilitiesReducer,
    ),
    EffectsModule.forFeature([
      ClientsEffects,
      JobTypeEffects,
      ProjectDetailsEffects,
      ProjectJobsEffects,
      ProjectsEffects,
      SettingsEffects,
      SurveyTasksEffects,
      TimeTrackingEffects,
      UsersEffects,
      PaginatedClientEffects,
      PaginatedJobTypeEffects,
      PaginatedPermitTaskEffects,
      PaginatedProjectEffects,
      PaginatedProjectJobEffects,
      PaginatedSurveyTaskEffects,
      PaginatedTimeTrackingEffects,
      PaginatedUserEffects,
    ]),
  ],
  providers: [UtilitiesFacade],
})
export class FrontendStoreModule {}
